import {
  databases,
  APPWRITE_DB_ID,
  APPWRITE_HACKATHON_COLLECTION_ID,
} from "../AppWrite/appwrite";
import { Query, ID } from "appwrite";

export const fetchGetAllHackathons = async () => {
  try {
    let allHackathons = [];

    const response = await databases.listDocuments(
      APPWRITE_DB_ID,
      APPWRITE_HACKATHON_COLLECTION_ID,
      [Query.orderDesc("$createdAt"), Query.limit(100)]
    );

    allHackathons = [...allHackathons, ...response.documents];
    return { success: true, hackathons: allHackathons };
  } catch (e) {
    console.error("Error fetching hackathons:", e);
    return { success: false, message: "Failed to fetch hackathons" };
  }
};

export const fetchCreateHackathon = async (payload) => {
  try {
    const response = await databases.createDocument(
      APPWRITE_DB_ID,
      APPWRITE_HACKATHON_COLLECTION_ID,
      ID.unique(),
      {
        Title: payload.title,
        Organizer: payload.organizer,
        startDate: payload.startDate,
        endDate: payload.endDate,
        mode: payload.mode,
        description: payload.description,
        registrationLink: payload.registrationLink,
      }
    );
    return { success: true, data: response };
  } catch (e) {
    console.error("Error creating job:", e);
    return { success: false, message: "Failed to add hackathon" };
  }
};

export const fetchGetHackathonById = async (hackathonId) => {
  try {
    const response = await databases.getDocument(
      APPWRITE_DB_ID,
      APPWRITE_HACKATHON_COLLECTION_ID,
      hackathonId
    );
    return { success: true, data: response };
  } catch (e) {
    console.error("Error fetching hackathon by ID:", e);
    return { success: false, message: "Not Found!" };
  }
};
